<template>
	<div class="import">
		<h3>Import Buy 1 Get 1</h3>
		<label class="csv-reader">
			<input type="file" @change="loadTextFromFile" />
		</label>

		<h1 v-if="promotionID">{{ promotionID }}</h1>

		<div class="importWrapper">
			<input name="name" class="textInput" placeholder="Discount Name" v-model="name" />

			<br />

			<input name="discountPrefix" class="textInput" :value="prefix" disabled />

			<br />

			<div class="shops">
				<h3>Shops</h3>

				<div class="shopsWrapper">
					<a @click="selectAllShops">Select All Shops</a>
					<div v-for="(data, index) of shops" v-bind:key="index">
						<b-checkbox class="checkbox" v-model="selectedShops" :native-value="data._id">{{ data.name }}</b-checkbox>
					</div>
				</div>
			</div>

			<div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today"></b-datepicker>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
					></b-datepicker>
				</b-field>
			</div>

			<div v-if="content" class="dataWrapper">
				<div class="importData">
					<div>BUY</div>
					<div>GET</div>
				</div>
				<div v-for="(getProducts, index) in content" v-bind:key="index" class="importData">
					<div>{{ index }}</div>
					<div>
						<div v-for="(item, pIndex) in getProducts" v-bind:key="pIndex">
							<div>{{ item }}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="button-wrapper">
				<div @click="submit" class="big-button">Save</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'importBuyOneGetOne',
	data: () => ({
		name: null,
		prefix: 'PPF',
		startingDate: null,
		endingDate: null,
		minDate: null,
		content: [],
		raw: '',
		shops: null,
		selectedShops: [],
		brands: [],
		promotions: [],
		promotionID: null
	}),
	mounted: function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		this.getShops()
	},
	watch: {
		startingDate: function(data) {
			this.minDate = data
		},

		content: function() {
			this.verifyContent()
		}
	},
	methods: {
		// Push to API
		submit: async function() {
			// Make sure there are required fields
			if (this.name == null || this.startingDate == null || this.endingDate == null || this.selectedShops.length < 1) {
				this.$buefy.toast.open({
					duration: 1000,
					message: 'Missing required fields',
					type: 'is-danger',
					position: 'is-top'
				})

				return
			}

			var data = {}
			var shops = []

			this.selectedShops.map(shop => {
				shops.push(shop)
			})

			data.name = this.name
			data.prefix = this.prefix
			data.shops = shops
			data.promotions = []

			this.promotions.map(promo => {
				const promotion = {}

				promotion.type = 'discount_product_buy_and_get_foc_from_list'
				promotion.condition = {}
				promotion.condition.target_products = promo.target_products
				promotion.condition.target_qty = 1
				promotion.condition.products = promo.products
				promotion.condition.qty = 1
				promotion.condition.repeat = true
				promotion.condition.date = {}
				promotion.condition.date.from = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')

				promotion.condition.date.to = this.$moment(this.endingDate)
					.set({ hour: 23 })
					.format('x')

				data.promotions.push(promotion)
			})

			const apiSubmit = await this.$api.submit({ data })

			if (apiSubmit !== undefined) {
				this.$swal.fire(apiSubmit.data.code)

				this.promotionID = apiSubmit.data.code

				this.name = null
				this.startingDate = null
				this.endingDate = null
				this.content = []
				this.selectedShops = []
				this.brands = []
				this.promotions = []
			} else {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Something went wrong...'
				})
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Select all shops
		selectAllShops: function() {
			this.selectedShops = []

			this.shops.map(data => {
				this.selectedShops.push(data._id)
			})
		},

		// Verify if the brand ID and values are valid
		verifyContent: async function() {
			for (var buyCode in this.content) {
				var data = {
					bd_code: buyCode
				}

				const apiBuyGetProduct = await this.$api.getProductDetail({
					data
				})

				if (apiBuyGetProduct !== undefined) {
					const toImport = {}
					toImport.target_products = []
					toImport.target_products.push(apiBuyGetProduct.data._id)
					toImport.products = []

					await Promise.all(
						this.content[buyCode].map(async getCode => {
							var data = {
								bd_code: getCode
							}

							const apiGetGetProduct = await this.$api.getProductDetail({
								data
							})

							if (apiGetGetProduct !== undefined) {
								toImport.products.push(apiGetGetProduct.data._id)
							} else {
								this.$swal.fire('Cannot find product ' + getCode)

								this.content = []
								this.promotions = []

								return
							}
						})
					)
					// console.log(toImport)

					this.promotions.push(toImport)
				} else {
					this.$swal.fire('Cannot find product ' + buyCode)

					this.content = []
					this.promotions = []

					return
				}
			}
			// this.content.map(async csvContent => {
			//   var buyData = {
			//     bd_code: csvContent.buy
			//   };
			//   const apiBuyGetProduct = await this.$api.getProductDetail({
			//     data: buyData
			//   });
			//   var getData = {
			//     bd_code: csvContent.get
			//   };
			//   const apiGetGetProduct = await this.$api.getProductDetail({
			//     data: getData
			//   });
			//   console.log(apiBuyGetProduct);
			//   console.log(apiGetGetProduct);
			// });
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Remove first row
				raw.shift()

				const newObj = {}
				// Loop every row to put it in array
				raw.map(async data => {
					var splitData = data.split(/,/)

					if (!newObj[splitData[0]]) {
						this.$set(newObj, splitData[0], [])
					}

					newObj[splitData[0]].push(splitData[1])
				})

				this.content = newObj
			}

			reader.readAsText(file)
		}
	}
}
</script>

<style scoped>
@import '../styles/Import.css';
</style>
